import { IBadge } from '@faire/web-api--source/indigofair/badges/IBadge';

export namespace IBadgeList {
  /**
   * Return an instance of IBadgeList with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IBadgeList>): IBadgeList =>
    ({
      badges: [],
      badge_xp_settings: [],
      ...(partial ?? {}),
    }) as IBadgeList;
}

/**
 * List of badges used in maps and for data compression
 */
export interface IBadgeList {
  badges: Array<IBadge>;
  /**
   * Internal BE only field for recording if a badge is introduced as an XP and should trigger setting assignment
   * Supports multiple settings since there are multiple positions
   */
  badge_xp_settings: Array<string>;
}
